module.exports = __webpack_public_path__ + "static/media/kr.931b1eaa.svg";